export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_MATCHINGS = 'SET_MATCHINGS';
export const SET_USER = 'SET_USER';
export const LOADING_USER = 'LOADING_USER';
export const SET_NGO = 'SET_NGO';
export const SET_VALID_NGO = 'SET_VALID_NGO'